@if (theme$ | async; as theme) {
    <div
        class="relative -right-10 bottom-46 flex size-56 items-center justify-center rounded-tl-full rounded-tr-full rounded-bl-full"
        [attr.role]="isOpen() ? 'dialog' : null"
        [ngClass]="{
            'gradient-border': !isOpen() && !hovering,
            'gradient-border-thin': !isOpen() && hovering,
            'gradient-border-dark': theme.mode === 'dark' && !isOpen(),
            'gradient-border-light': theme.mode === 'light' && !isOpen(),
            'origin-bottom-right scale-[1.7]': hovering && !isOpen(),
            'right-0 bottom-[100vh] h-[100vh] w-[40vw] translate-x-0 translate-y-0 rounded-tl-none rounded-tr-none rounded-bl-none bg-surface-A':
                isOpen(),
        }"
        [style]="
            'transition: all ' +
            ANIMATION_DURATION_MS +
            'ms,border .1s,border-radius .1s,border-color .1s;'
        "
    >
        @if (showButton()) {
            <button
                #aiFabButton
                class="flex size-full items-center justify-center gap-x-4 rounded-full transition-all"
                type="button"
                [attr.aria-label]="'AI.ACCESS_AI_SECTION' | translate"
                [ngClass]="{
                    'scale-[0.7]': hovering && !isOpen(),
                }"
                (blur)="hovering = false"
                (click)="toggleOpen(!isOpen())"
                (focus)="hovering = true"
                (mouseout)="hovering = false"
                (mouseover)="hovering = true"
            >
                <interacta-icon class="size-24" [icon]="'book-open'" />
                @if (hovering) {
                    <p class="typo-h5 pointer-events-none text-text">AI</p>
                }
            </button>
        }
    </div>
}
